import { SolutionManager } from "./solution-manager";
import { AccountingCloseError } from "./accounting-close-error";

export class AccountingCloseTaskStatus {
  id?: number;
  version?: number;
  completed?: boolean;
  errors: AccountingCloseError[];
  isUserTask?: boolean;
  accountingCloseTaskName?: string;

}

export class AccountingCloseTask extends SolutionManager {
  taskName?: string;
  isUserTask?: boolean;
  accountingCloseType?: string;
  systemTaskType?: string;
  isCalendarSystemTaskType?: boolean;

  constructor (managingOrgId?: number) {
    super(managingOrgId);
  }
}